import $ from 'jquery';

/*
Handle the UI for the STB management screen:
- populate the hidden input with the selected STB ids
- handle the Select All checkbox
*/
export default (function () {
  const bulkUpdateModal = document.getElementById('bulk-update-modal');
  const stbBulkUpdateForm = bulkUpdateModal ? bulkUpdateModal.querySelector('form') : null;
  const stbIdInput = document.getElementById('id_stbs');
  const stbModal = document.getElementById('bulk-update-modal');
  const stbCheckboxes = document.querySelectorAll('.stb-checkbox');
  const stbBulkUpdateButton = document.getElementById('stb-bulk-update-button');
  const bulkUpdateNotice = document.getElementById('bulk-update-modal-notice');
  const selectAllCheckbox = document.getElementById('stb-select-all-checkbox');

  const populateStbHiddenInput = () => {
    // convert selected STB checkboxes to an array of values for the hidden bulk update form input
    // also update the notice text
    const selected = Array.from(stbCheckboxes).filter((cb) => cb.checked);
    const selectedValues = selected.map((cb) => cb.value);
    if (selectedValues.length > 0) {
      stbIdInput.value = selectedValues.join(',');
      bulkUpdateNotice.textContent = `You have selected ${selectedValues.length} STBs.`;
    } else {
      bulkUpdateNotice.textContent = 'You have not selected any STBs!';
    }
  };

  const toggleBulkUpdateButton = () => {
    // disable bulk update button if no STBs are selected
    stbBulkUpdateButton.disabled = !Array.from(stbCheckboxes).some((cb) => cb.checked);
  };

  const handleSelectAllCheckboxChange = () => {
    // toggle checkboxes on/off when select all is changed
    console.log('select all checkbox changed');
    if (selectAllCheckbox.checked) {
      Array.from(stbCheckboxes).forEach((cb) => (cb.checked = true));
    } else {
      Array.from(stbCheckboxes).forEach((cb) => (cb.checked = false));
    }
    toggleBulkUpdateButton();
  };

  return {
    init: function () {
      if (
        !stbBulkUpdateForm ||
        !stbIdInput ||
        !stbModal ||
        !stbCheckboxes ||
        !bulkUpdateNotice ||
        !selectAllCheckbox
      ) {
        // there may not be any results, so don't initialize the UI
        return;
      }

      toggleBulkUpdateButton();

      // watch for changes to each stb checkbox
      $(stbCheckboxes).on('change', toggleBulkUpdateButton);

      // watch for changes to the select all checkbox
      $(selectAllCheckbox).on('change', handleSelectAllCheckboxChange);

      // populate the hidden input with the selected STB ids when the modal is shown
      $(stbModal).on('show.bs.modal', populateStbHiddenInput);
    },
  };
})();
